import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPost } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";

export const ForgotPasswordAction = createAsyncThunk("forgotPassword",
    async (arg, { rejectWithValue }) => {
        try {
            const response = await doPost(urls?.forgotPassword, arg);
            return response;
        } catch (error) {
            return rejectWithValue(error)
        }
    })

const ForgotPasswordSlice = createSlice({
    name: "forgotPassword",
    initialState: {
        isLoading: false,
        data: false,
        error: null,
        success: false,
    },
    reducers: {
        ForgotPasswordReset: () => {
            return {
                isLoading: false,
                data: false,
                error: null,
                success: false,
            };
        },
    },
    extraReducers: {
        [ForgotPasswordAction.pending]: (state) => {
            state.isLoading = true;
            state.error = null;
            state.success = false;
        },
        [ForgotPasswordAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.data = payload;
            state.error = null;
            state.success = true;
        },
        [ForgotPasswordAction.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
            state.success = false;
        },
    }
})

export const { ForgotPasswordReset } = ForgotPasswordSlice.actions
export default ForgotPasswordSlice.reducer;